<template>
	<div class="homepage">
		<!-- 头部 -->
		<Header @toggleLang="toggleLang"></Header>
		<main>
			<!--首页海报 GO-->
			<div class="swiper-container" v-if="banner.length>0">
				<swiper :options="swiperOption" ref="mySwiper" :pagination="{clickable:true}">
					<div class="swiper-slide" v-for="(item,index) in banner" :key="index" @click="go_open(item.outlink)"
						:style="'background:url('+item.image+')'" v-if="item.image">
						<div style="background: #ffffff;"></div>
						<!-- <div class="photo"> <img :src="item.image" alt="佳信官方主页"></div> -->
					</div>
				</swiper>
				<!-- 如果需要分页器 -->
				<div class="swiper-pagination"></div>
				<!-- 如果需要导航按钮 -->
				<div class="swiper-button-prev"></div>
				<div class="swiper-button-next"></div>
				<!-- 如果需要滚动条 -->
				<div class="swiper-scrollbar"></div>
			</div>
			<!-- 佳信头条 GO -->
			<div class="m-head-line container-fluid ">
				<el-row class="inline-top">
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18">
						<el-row :gutter="40">
							<el-col :span="6">
								<div class="bar toutiao">
									<div class="left">
										<p class="text-left let-spa7">佳信头条</p>
										<p class="text-uppercase let-spa4">Headlines</p>
									</div>
								</div>
							</el-col>
							<el-col :span="1" style="padding: 0;">
								<div class="b_right"></div>
							</el-col>
							<el-col :span="17">
								<div class="right scroll-wrap">

									<div class="scroll_parent_box scroll">
										<!-- 
										<div class="big">
											<vue-seamless-scroll :data="toutiaoList" :class-option="scrollsingleOption">
												<div class="scroll_item list pointer" ref="myScroll" id="myScroll"
													v-for="(item, index) in toutiaoList" :key="index"
													@click="goDetail(item)">
													<div class="b_btn">
														<div class="content pointer">
															<div class="content-b">
																<label
																	class="text pointer">{{item.publishtime_text}}</label>
																<img src="@/assets/hot.svg" alt=""
																	v-if="item.flag=='hot'">
																<span v-if="item.type=='news'"
																	class="btn_radius btn-default padding_l_13">{{lang=='CN' ?'新闻':'Journalism'}}</span>
																<span v-if="item.type=='video'"
																	class="btn_radius btn-default padding_l_13">{{lang=='CN' ?'视频':'Video'}}</span>
																<span v-if="item.type=='studio'"
																	class="btn_radius btn-default">{{lang=='CN' ?'直播':'BroadcastRoom'}}</span>
															</div>
															<label
																class="pointer text2 line-1">{{lang=='CN' ?item.cn_title:item.en_title}}</label>
														</div>
														<div class="enter-the-studio">
															<span v-if="item.type=='video'"
																class="btn_square"><em>{{lang=='CN' ?'查看视频':'View the video'}}</em></span>
															<span v-if="item.type=='news'"
																class="btn_square"><em>{{lang=='CN' ?'了解详情':'Find out details'}}</em></span>
															<span v-if="item.type=='studio'"
																class="btn_square"><em>{{lang=='CN' ?'进入直播间':'Enter the studio'}}</em></span>
														</div>
													</div>
												</div>
											</vue-seamless-scroll>
										</div>

 -->
										<vue-seamless-scroll :data="toutiaoList" :class-option="scrollOption">
											<div class="scroll_item list pointer" ref="myScroll" id="myScroll"
												v-for="(item, index) in toutiaoList" :key="index"
												@click="goDetail(item)">
												<div class="b_btn">
													<div class="content pointer">
														<div class="content-b">
															<label
																class="text pointer">{{item.publishtime_text}}</label>

															<img src="@/assets/hot.svg" alt="" v-if="item.flag=='hot'">

															<span v-if="item.type=='news'"
																class="btn_radius btn-default padding_l_13">{{lang=='CN' ?'新闻':'Journalism'}}</span>
															<span v-if="item.type=='video'"
																class="btn_radius btn-default padding_l_13">{{lang=='CN' ?'视频':'Video'}}</span>
															<span v-if="item.type=='studio'"
																class="btn_radius btn-default">{{lang=='CN' ?'直播':'BroadcastRoom'}}</span>
														</div>
														<label
															class="pointer text2 line-1">{{lang=='CN' ?item.cn_title:item.en_title}}</label>
													</div>
													<div class="enter-the-studio">
														<span v-if="item.type=='video'"
															class="btn_square"><em>{{lang=='CN' ?'查看视频':'View the video'}}</em></span>
														<span v-if="item.type=='news'"
															class="btn_square"><em>{{lang=='CN' ?'了解详情':'Find out details'}}</em></span>
														<span v-if="item.type=='studio'"
															class="btn_square"><em>{{lang=='CN' ?'进入直播间':'Enter the studio'}}</em></span>
													</div>
												</div>
											</div>
										</vue-seamless-scroll>
									</div>

								</div>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
				<el-row :gutter="40">
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18">
						<div class="headline-more">
							<div class="list_botton" style="float: right;">
								<div @click="go_list(145)" class="btn_square btn_more pointer"><em>查看更多
										MOER</em><span></span></div>
							</div>
						</div>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
			</div>
			<!-- 品牌故事 -->
			<div class="brand-story ">
				<div class="story1" :style="{backgroundImage: 'url(' +zidiyiData.brandstory.files + ')'}">
					<div class="left story_title">
						<p class="text-left   let-spa7">企业简介</p>
						<p class="text-uppercase let-spa7">about us</p>
					</div>
					<div class="txt"
						v-html="lang=='CN' ? zidiyiContent.area1.cn_content:zidiyiContent.area1.en_content"></div>
					<div @click="goDetailAbout(90)" class="btn_square btn_more pointer"><em>查看更多 MOER</em><span></span>
					</div>
				</div>
				<div class="story2">
					<img class="story2_pic img-responsive" src="@/assets/img/bg_brand.jpg" alt="品牌故事" />
				</div>
			</div>
			<!--品牌故事 GO-->
			<div class="m-story container-fluid " data-wow-duration='1s' data-wow-delay='1s'>
				<el-row>
					<el-col :span="24">
						<el-row :gutter="35" style="display: flex;">
							<el-col class="pointer" :span="8" v-for="(item,index) in paipaiData" v-if="index<4"
								:key="index">
								<!-- <div @click.stop="goDetail(item)"> -->
								<div @click.stop="next_go(item)">
									<div class="pic pic_h264">
										<img class="pic gushipic css3 hover_img img-responsive pointer"
											:src="item.image || ''" />
									</div>
									<div class="span">
										<p class="title text-uppercase let-spa2 line-1">{{item.company.cn_name}}
											<small>{{item.company.en_name}}</small>
										</p>
										<p class="center line-2">{{lang=='CN' ?item.cn_title:item.en_title}}</p>
										<cite title="Source Title" class="">&nbsp;&nbsp;</cite>
										<div class="times">
											<span class="let-spa2">{{item.publishtime_text}}</span>
											<div class="btn_square btn_more btn_small">
												<em>{{lang=='CN' ?'了解详情':'Find out details'}} </em><span></span>
											</div>
										</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
			<!-- 视频新闻 -->
			<div class="m-video container-fluid  " data-wow-duration='1s' data-wow-delay='1s'>
				<el-row class="p_back">
					<el-col :span="24" class="p_back_btn">
						<div class="p_back_btn-L">
							<div class="btn" @click="last"><span class="glyphicon" aria-hidden="true">
									<img class="pic img-responsive rotate arrows_green"
										src="@/assets/img/arrows_green.png">
									</img>
								</span></div>
						</div>
						<div class="video" v-if="shipinNewsIndex==index" v-for="(item,index) in shipinNewsData"
							:key="index">
							<video :src="item.video" height="" controls="controls" :poster="item.image"></video>
						</div>
						<div class="p_back_btn-R">
							<div class="btn" @click="next">
								<span class="glyphicon" aria-hidden="true">
									<img class="pic img-responsive arrows_green"
										src="@/assets/img/arrows_green.png"></img>
								</span></span>
							</div>
						</div>
					</el-col>

				</el-row>
				<el-row class="">
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18">
						<div class="menu">
							<el-row class="">
								<el-col :span="20">
									<div class="left">
										<p class="text-left   let-spa7">视频新闻</p>
										<p class="text-uppercase let-spa-1">Video content</p>
									</div>
								</el-col>
								<el-col :span="4">
									<div class="right ">
									</div>
								</el-col>
							</el-row>
						</div>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>

				<el-carousel :height="screenWidth>=1920?'400px':'330px'" :interval="5000" arrow="always"
					class="carousel" indicator-position="none" :autoplay="false">
					<el-carousel-item v-for="items in Math.ceil(shipinNewsData.length/4)" :key="items">
						<el-row :gutter="30" class="news-list overflowX">
							<el-col class="pointer"
								v-if="index==(items-1)*4 ||index==(items-1)*4+1||index==(items-1)*4+2||index==(items-1)*4+3"
								:span="6" v-for="(item,index) in shipinNewsData" :key="index">
								<div @click.stop="goDetail(item)">
									<div class="pic pic_h242">
										<img class="pic gushipic css3 hover_img img-responsive" :src="item.image" />
									</div>
									<p class="title line-2">{{lang=='CN' ?item.cn_title:item.en_title}}</p>
									<div class="times">
										<img class="brand img-responsive" :src="item.company.image" />
										<div class="btn_square btn_more btn_small">
											<em>{{lang=='CN' ?'查看详情':'View Details'}} </em><span></span>
										</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</el-carousel-item>
				</el-carousel>
			</div>
			<!-- 品牌项目 -->
			<div class="brand-project container-fluid  animated" data-wow-duration='1s' data-wow-delay='1s'>
				<el-row class="title">
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="21">
						<el-row :gutter="20">
							<el-col :span="6">
								<div class="left">
									<p class="text-left  let-spa7">品牌项目 </p>
									<p class="text-uppercase active_style let-spa-1">Brand project</p>
								</div>
							</el-col>
							<el-col :span="18">
								<div class="right_pic ">
									<img class="pic img-responsive" src="@/assets/img/logo_sub.png" />
								</div>
							</el-col>
						</el-row>
						<el-row :gutter="20" style="margin-right: -15px;">
							<el-col :span="5">
								<div class="nav_pic overflowX">
									<div class="nav_pic_list">
										<div class="pics pointer" v-for="(item,index) in categoryList"
											@click="change_index(item.id)"
											v-if="index==categoryListStr[zidiyiDataTime*6] || index==categoryListStr[zidiyiDataTime*6+1] || index==categoryListStr[zidiyiDataTime*6+2] || index==categoryListStr[zidiyiDataTime*6+3] || index==categoryListStr[zidiyiDataTime*6+4] || index==categoryListStr[zidiyiDataTime*6+5]"
											:key="index">
											<div class="pic" :class="yjy_index==item.id?'active':''">
												<img :src="item.image_text" alt="" />
											</div>
										</div>
									</div>
									<el-row :gutter="20" style="margin:0px -15px;">
										<el-col :span="12" style="padding: 0 10px 0 15px;">
											<div class="btn" @click="zidiyiDataLast"><span class="glyphicon"
													aria-hidden="true">
													<img fit="contain"
														style="height: 20px;width: auto; margin-top: 20px;vertical-align: middle;"
														class="pic img-responsive rotate arrows_green"
														src="@/assets/img/arrows_green.png"></img>
												</span></div>
										</el-col>
										<el-col :span="12" style="padding: 0 15px 0 10px;">
											<div class="btn " @click="zidiyiDataNext"><span class="glyphicon"
													aria-hidden="true">
													<img fit="contain"
														style="height: 20px;width: auto; margin-top: 20px;vertical-align: middle;"
														class="pic img-responsive arrows_green"
														src="@/assets/img/arrows_green.png"></img>
												</span></div>
										</el-col>
									</el-row>
								</div>
							</el-col>
							<el-col :span="15">
								<div class="information ">
									<div class="title "><span class="text-uppercase t"><text></text> 资讯 info</span>
									</div>
									<div class="list b_btn pointer" @click.stop="goDetail(item)"
										v-for="(item,index) in brandNewsList" v-if="index<6" :key="index">
										<div class="content" style="display: flex;">
											<div class="content-b">
												<span class="">{{item.publishtime_text}}</span>
												<span v-if="item.type=='video'"
													class="btn_radius btn-default">{{lang=='CN' ?'视频':'Video'}}</span>
												<span v-if="item.type=='news'"
													class="btn_radius btn-default">{{lang=='CN' ?'新闻':'Journalism'}}</span>
												<span v-if="item.type=='studio'"
													class="btn_radius btn-default">{{lang=='CN' ?'直播':'BroadcastRoom'}}</span>
											</div>
											<label
												class="pointer text2 line-1">{{lang=='CN' ?item.cn_title:item.en_title}}</label>
										</div>
										<div class="enter-the-studio " @click="goDetail(item)">
											<span v-if="item.type=='studio'"
												class="btn_square"><em>{{lang=='CN' ?'进入直播间':'Enter the studio'}}</em></span>
											<span v-if="item.type=='news'"
												class="btn_square"><em>{{lang=='CN' ?'了解详情':'Find out details'}}</em></span>
											<span v-if="item.type=='video'"
												class="btn_square"><em>{{lang=='CN' ?'查看视频':'View the video'}}</em></span>
										</div>
									</div>
									<div class="list b_btn pointer" v-if="brandNewsList.length==0" :key="index">
										暂无数据~
									</div>
									<div class="list_botton ">
										<div @click="go_list(yjy_index)" class="btn_square btn_more pointer">
											<em>查看更多 MOER</em><span></span>
										</div>
									</div>
								</div>
							</el-col>
							<el-col style="padding-right: -15px;margin-top: 15px;" :span="4" class="information ">
							</el-col>
						</el-row>
					</el-col>
				</el-row>
			</div>
			<!-- 党建.公益 -->
			<div class="m-charity container-fluid ">
				<el-row class="title">
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18">
						<div class="left">
							<p class="text-left   let-spa7">党建 • 公益 </p>
							<p class="text-uppercase let-spa-1">public benefit activities</p>
						</div>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18">
						<el-row class="information pointer" v-for="(item,index) in dangjianGongyiData" :key="index">
							<div @click.stop="goDetail(item)">
								<el-col :span="12">
									<div class="dj_ovhd pic_h357"><img class="pic css3 hover_img img-responsive"
											:src="item.image" /></div>
								</el-col>
								<el-col :span="12">
									<div class="ncol-md-6">
										<div class="title line-2">
											{{lang=='CN' ?item.cn_title:item.en_title}}
										</div>
										<div class="text-left line-3">
											{{lang=='CN' ?item.cn_digest:item.en_digest}}
										</div>

										<div class="list_botton" style="display: block;">
											<div class="spe">{{item.publishtime_text}}</div>
											<div class="btn_square btn_more btn_small">
												<em>{{lang=='CN' ?'查看详情':'View Details'}} </em><span></span>
											</div>
										</div>
									</div>
								</el-col>
							</div>
						</el-row>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
			</div>
			<!-- 发展大事记 -->
			<div class="m-great-things container-fluid ">
				<el-row>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18" style="padding: 0 !important;">
						<el-row class="head">
							<el-col :span="6" style="padding: 4px !important;">
								<div class="left">
									<p class="text-left" style="letter-spacing: 5px;">发展大事记</p>
									<p class="text-uppercase let-spa2">Memorabilia</p>
								</div>
							</el-col>
							<el-col :span="18">
								<div class="right ">
									<div class="panel">
										<span @click.stop="choose_year(index)" class="pointer2"
											:class="dataListMindex==index ? 'active' : ''"
											v-for="(item,index) in dataList" :key="index"
											v-if="dataList6.indexOf(index)!=-1">{{index}}</span>
									</div>

									<!-- 			<div class="b">
										<div class="btn" @click="next_you(dataListMindex)">
											<img style="width:40px;height: 40px;" src="@/assets/img/arrow-left.png" />
										</div>
										<div class="btn" @click="next_zuo(dataListMindex)">
											<img style="width:40px;height: 40px;" src="@/assets/img/arrow-right.png" />
										</div>
									</div> -->

									<div class="b_more pointer2" @click="go_fzmemorabilia()">查看更多 MORE</div>

								</div>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
				<el-carousel ref="welcome" :height="screenWidth>=1920?'250px':'320px'" :interval="5000" arrow="never"
					indicator-position="none" :autoplay="false" v-if="dataList[dataListMindex].length">

					<el-carousel-item v-for="items in Math.ceil((dataList[dataListMindex].length)/4)" :key="items">
						<el-row :gutter="43.5" class="nav-list">
							<el-col :span="6" class="list"
								v-if="index==(items-1)*4 || index==(items-1)*4+1 || index==(items-1)*4+2 || index==(items-1)*4+3"
								v-for="(item,index) in dataList[dataListMindex]" :key="index">
								<div>
									<div class="bg-bai"></div>
									<h2><span></span>{{item.date2}} <small
											class="text-capitalize">{{item.date3}}</small></h2>
									<p class="line-4">{{lang=='CN' ?item.cn_text:item.en_text}}</p>
								</div>
							</el-col>
						</el-row>
					</el-carousel-item>
				</el-carousel>
				<el-row class="go_direction">
					<el-col :span="10">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="4" class="go_direction">
						<el-row :gutter="80">
							<el-col :span="12">
								<div class="btn" @click="dataListTimeLast"><span class="glyphicon" aria-hidden="true">
										<img fit="contain" style="height: 20px;width: 30px;margin: 25px 0;"
											class="pic img-responsive  arrows_green"
											src="@/assets/img/icon-left.svg"></img>
									</span></div>
							</el-col>
							<el-col :span="12">
								<div class="btn" @click="dataListTimeNext"><span class="glyphicon" aria-hidden="true">
										<img fit="contain" style="height: 20px;width: 30px; margin: 25px 0;"
											class="pic img-responsive arrows_green" src="@/assets/img/icon-right.svg">
										</img>
									</span></div>
							</el-col>
						</el-row>
						<div>
						</div>
					</el-col>
					<el-col :span="10">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
			</div>
			<!-- 动态+文化 -->
			<div class="m-monthly ">
				<el-row class="inline-top">
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18">
						<el-row :gutter="40">
							<el-col :span="24">
								<div>
									<div class="left">
										<p class="text-left   let-spa7">科技+文化资讯 </p>
										<p class="text-uppercase let-spa-1">Cultural consultation</p>
									</div>
									<div class="left-block">
										<div class="pointer-blck" v-for="(item,index) in kjwhData" :key="index"
											@click.stop="goDetail(item)" v-if="index<=1">
											<div class="pic pointer pic_h180" @click.stop="goDetail(item)">
												<img class="brand css3 hover_img img-responsive" :src="item.image" />
											</div>
											<div class="line-1 title pointer" @click.stop="goDetail(item)">
												{{lang=='CN' ?item.cn_title:item.en_title}}
											</div>
										</div>

									</div>
									<div class="bottom">
										<div class="bottom_left">
											<div class="list pointer" v-if="1<index && index%2==0"
												:class="index==kjwhData.length-1? 'b_btn':''"
												v-for="(item,index) in kjwhData" :key="index"
												@click.stop="goDetail(item)">
												<div class="content">
													<label class="text">{{item.publishtime_text}}</label>
													<label
														class="line-1 text2 pointer">{{lang=='CN' ?item.cn_title:item.en_title}}</label>
												</div>
											</div>
										</div>
										<div class="bottom_right">
											<div class="list pointer" v-if="1<index && index%2==1"
												:class="index==kjwhData.length-1? 'b_btn':''"
												v-for="(item,index) in kjwhData" :key="index"
												@click.stop="goDetail(item)">
												<div class="content">
													<label class="text">{{item.publishtime_text}}</label>
													<label
														class="line-1 text2 pointer">{{lang=='CN' ?item.cn_title:item.en_title}}</label>
												</div>
											</div>
										</div>

									</div>
								</div>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
				<el-row class="inline-top" style="marker:unset;padding: 0;">
					<el-col :span="24">
						<div class="list_botton" style="margin: 0;">
							<div class="btn_square btn_more pointer" @click='go_wenhua'><em>查看更多 MOER</em><span></span>
							</div>
						</div>
					</el-col>
				</el-row>
			</div>
			<!-- 员工风采 -->
			<div class="m-staff  data-wow-duration='1s' data-wow-delay='1s'">
				<el-row>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18">
						<div class="left">
							<p class="text-left let-spa2">企业文化</p>
							<p class="text-uppercase">corporate culture</p>
						</div>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
				<el-carousel :height="screenWidth>=1920?'420px':'330px'" :interval="5000" arrow="always"
					indicator-position="none" :autoplay="false">
					<el-carousel-item v-for="items in Math.ceil(shipinNewsData.length/4)" :key="items">
						<el-row :gutter="30" class="overflowX" style="padding-top: 16px;">
							<el-col
								v-if="index==(items-1)*4 ||index==(items-1)*4+1||index==(items-1)*4+2||index==(items-1)*4+3"
								:span="6" class="pointer" v-for="(item,index) in qywhYgfcData" :key="index">
								<div class="c23" @click.stop="goDetail(item)">
									<div class="pic pic_h242">
										<img class="pic css3 hover_img img-responsive" :src="item.image" />
									</div>
									<div class="title line-2 pointer">{{lang=='CN' ?item.cn_title:item.en_title}}</div>
									<div class="time ">
										<span>{{item.publishtime_text}}</span>
										<div class="btn_square btn_more btn_small">
											<em>{{lang=='CN' ?'查看详情':'View Details'}} </em><span></span>
										</div>
									</div>
								</div>
							</el-col>
						</el-row>
					</el-carousel-item>
				</el-carousel>
			</div>
			<!-- 影视作品 -->
			<div class="m-films ">
				<el-row>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
					<el-col :span="18">
						<div class="left">
							<p class="text-left let-spa7">影视作品</p>
							<p class="text-uppercase">Film and television works</p>
						</div>
					</el-col>
					<el-col :span="3">
						<div>&nbsp;</div>
					</el-col>
				</el-row>
				<el-carousel :height="screenWidth>=1920?'600px':'440px'" :interval="5000" arrow="always"
					indicator-position="none" :autoplay="false">
					<el-carousel-item v-for="items in Math.ceil(shipinNewsData.length/5)" :key="items">
						<el-row class="inline-top">
							<el-col :span="24">
								<div class="nav_list overflowX">
									<div v-if="index==(items-1)*5 ||index==(items-1)*5+1||index==(items-1)*5+2||index==(items-1)*5+3||index==(items-1)*5+4"
										class="list col-xs-12 col-lg-5 c23" v-for="(item,index) in yszxData"
										:key="index">
										<div class="pic pic_h264" @click.stop="goDetail(item)">
											<img class="pic css3 hover_img img-responsive pointer" :src="item.image" />
										</div>
										<label class="title line-1">{{lang=='CN'?item.cn_title:item.en_title}}</label>
										<p class="detail">{{item.seo3}}</p>
									</div>
								</div>
							</el-col>
						</el-row>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="mask_proup" v-if="isProup" @click="closeProup"></div>
			<div class="proup" v-if="isProup">
				<div class="cont">
					<div class="close-proup" @click="closeProup">关闭</div>
					<div class="pic" @click="goOutlink(notice.outlink)">
						<img :src="notice.image" />
						<div class="txt txt1 css3">
							{{lang=='CN'?'开始时间':'Start Time'}}：<span>{{notice.begin_time_text}}</span>
						</div>
						<div class="txt txt2 css3">
							{{lang=='CN'?'结束时间':'End Time'}}：<span>{{notice.end_time_text}}</span>
						</div>
					</div>
					<div class="info">
						<img class="logo" src="@/assets/img/logo1.png">
						<img class="qrcode" :src="notice.ewm">
						<div class="tit line-1">{{lang=='CN'?'扫码进入直播间':'Scan into live room'}}</div>
					</div>
				</div>
			</div>
		</main>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import vueSeamlessScroll from "vue-seamless-scroll";
	import {
		channel_list,
		archives_list,
		archives_list_new,
		get_notice,
		get_banner,
		get_file_all,
		get_content_all,
		history_lst,
		add_pv,
	} from '@/api/api.js'
	import {
		WOW
	} from 'wowjs'
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper"
	import 'swiper/css/swiper.css'
	export default {
		components: {
			Header,
			Footer,
			swiper,
			swiperSlide,
			vueSeamlessScroll
		},
		data() {
			return {
				animate: false,
				publicShow: false,
				p_index: 0,
				shoppShow: false,
				s_index: 0,
				parent_id: 7,
				screenWidth: document.body.clientWidth,
				list: [],
				page: 1,
				per_page: 10,
				copyHtml: '', //复制多一份防止滚动到后面出现空白
				scrollTop: 0,
				timer: '',
				speed: 15,
				doubleArr: [], //头条每2个为一组
				brandNewsList: [{
					publishtime_text: '',
					type: '',
					cn_title: '',
					en_title: ''
				}], //内容列表
				content: {}, //内容详情
				total: '',
				company_id: 1, //公司ID
				banner: [{
					image: '',
					outlink: ''
				}],
				toutiaoList: [{
					publishtime_text: '',
					type: '',
					cn_title: '',
					en_title: ''
				}], //头条列表
				paipaiData: [{
					image: '',
					company: {
						cn_name: '',
						en_name: ''
					},
					cn_title: '',
					en_title: '',
					publishtime_text: ''
				}], //品牌故事
				shipinNewsData: [{
					image: '',
					cn_title: '',
					en_title: '',
					company: {
						image: ''
					}
				}], //视频新闻
				shipinNewsIndex: 0,
				dangjianGongyiData: [{
					image: '',
					cn_title: '',
					en_title: '',
					cn_digest: '',
					en_digest: '',
					publishtime_text: ''
				}], //党建公益
				pinpai_id: 45,
				zidiyiData: {
					brandstory: {
						files: ''
					}
				}, //品牌项目
				zdyIndex: 0, //
				zidiyiDataIndex: '',
				notice: {
					image: '',
					begin_time_text: '',
					end_time_text: '',
					ewm: ''
				},
				isProup: false,
				categoryList: [{
					id: '',
					image_text: ''
				}], //品牌故事
				categoryListStr: 0,
				zidiyiContent: {
					area1: {
						cn_content: '',
						en_content: '',
					}
				}, //自定义富文本
				zidiyiDataTime: 0, //
				swiperOption: {

					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					slidesPerView: 1,
					// 显示分页
					pagination: {
						el: ".swiper-pagination",
						clickable: true //允许分页点击跳转
					},
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					}
				},
				swiperOption1: {
					direction: "vertical",
					autoplay: {
						delay: 3000,
						// stopOnLastSlide: false,
						disableOnInteraction: false
					},
					loop: true,
					slidesPerView: 1,
					// 显示分页
					pagination: {
						el: ".swiper-pagination",
						clickable: true //允许分页点击跳转
					},
					// 设置点击箭头
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev"
					}
				},
				kjwhData: [{
					image: '',
					cn_title: '',
					en_title: '',
					publishtime_text: '',
				}], //科技文化资讯
				qydtData: [{
					image: '',
					cn_title: '',
					en_title: '',
					publishtime_text: '',
				}], //科技文化资讯
				qywhYgfcData: [{
					image: '',
					cn_title: '',
					en_title: '',
					publishtime_text: ''
				}], //企业文化员工风采
				yszxData: [{
					image: '',
					cn_title: '',
					en_title: '',
					seo3: ''
				}], //影视资讯
				dataList: [{
					date2: '',
					date3: '',
					cn_text: '',
					en_text: ''
				}], //发展大事件
				dataList6: [], //近6年数组
				dataListMindex: 0,
				dataListMin: '',
				dataListMax: '',
				dataListTime: 0, //时间点
				lang: localStorage.getItem('lang') || 'CN',
				screenWidth: document.body.clientWidth || 1920, // 屏幕尺寸
			}
		},
		created() {
			let that = this
			localStorage.setItem('current', 0)
			this.getZidiyiData()
			this.getAllNewsList()
			this.getCateList() //或
			this.addLocatPath() //添加足迹
			this.getZidiyiContent() //自定义富文本
			this.getNotice() //弹窗公告
			this.getToutiaoList() //头条
			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},

		computed: {

			scrollsingleOption() {
				return {
					step: 1, // 数值越大速度滚动越快
					limitMoveNum: 1, // 开始无缝滚动的数据量 this.bbsData.length
					hoverStop: false, // 是否开启鼠标悬停stop
					direction: 0, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
				}
			},
			scrollOption() {
				return {
					step: 1, // 数值越大速度滚动越快
					limitMoveNum: 3, // 开始无缝滚动的数据量 this.bbsData.length
					hoverStop: false, // 是否开启鼠标悬停stop
					direction: 0, // 0向下 1向上 2向左 3向右
					openWatch: true, // 开启数据实时监控刷新dom
					singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
					singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
					waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
				}
			},

		},
		mounted() {
			this.getBanner() //走马灯
			const that = this
			if (window.screenWidth == undefined) {
				this.screenWidth = 1920
			}
			window.onresize = () => {
				return (() => {
					window.screenWidth = document.body.clientWidth
					if (window.screenWidth > 1400) {
						this.screenWidth = 1920
					}
					if (window.screenWidth <= 1400) {
						this.screenWidth = 1400
					}
				})()
			}
			this.parent_id = this.$route.query.parent_id || this.parent_id
			let data = {
				parent_id: this.parent_id
			}
			channel_list(data).then((res) => {
				if (res.code == 1) {
					this.list = res.data
					if (res.data) {
						this.jx_index = this.list[this.index].id

					}
				}
			}).catch(err => {});
			this.getFzdsj() //发展大事件



		},

		methods: {

			getAllNewsList() {
				let temp = [],
					that = this,
					data = {
						channel_id: '145,48,49,51,59,30,53,22',
						per_page: '5,4,12,2,5,10,4,10'
					},
					temparr = []
				archives_list_new(data).then((res) => {
					temp = res.data
					this.paipaiData = temp[1] ? temp[1].data : temp //品牌故事48  //文旅136 资本132 建设140 正佳113
					this.shipinNewsData = temp[2] ? temp[2].data : temp //视频新闻
					this.dangjianGongyiData = temp[3] ? temp[3].data : temp //党群公益
					this.kjwhData = temp[5] ? temp[5].data : temp //科技资讯
					this.qywhYgfcData = temp[6] ? temp[6].data : temp //员工风采
					this.yszxData = temp[7] ? temp[7].data : temp //影视作品
				}).catch(err => {});
			},


			// 首页banner
			getBanner() {
				let data = {
					company_id: this.company_id,
					tag: '首页'
				}
				get_banner(data).then((res) => {

					this.banner = res.data
				}).catch(err => {});
			},

			//头条
			getToutiaoList(id, per_page) {
				let data = {
					page: 1,
					is_top: 1,
					per_page: 5,
				}
				archives_list(data).then((res) => {
					if (res.code == 1) {
						this.toutiaoList = res.data.data
					}
				}).catch(err => {});
			},

			//获取品牌二级栏目
			getCateList() {
				let that = this
				let data = {
					isblock: 1
				}
				channel_list(data).then((res) => {
					if (res.code == 1) {
						this.list = res.data
						if (res.data) {
							that.categoryList = res.data
							this.categoryListStr = Object.keys(this.categoryList)
							this.getArchivesList(this.categoryList[0].id)
							this.yjy_index = this.categoryList[0].id //默认第一组数据
						}
					}
				}).catch(err => {});
			},
			//品牌项目 7个LOGO 或更多
			getArchivesList(id, per_page) {
				let data = {
					channel_id: id,
					per_page: 5,
					page: 1
				}
				archives_list(data).then((res) => {
					if (res.code == 1) {
						this.brandNewsList = res.data.data
						this.total = res.total
					}
				}).catch(err => {});
			},

			//点击更新列表
			change_index(num) {
				this.yjy_index = num

				this.getArchivesList(num)
			},

			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			next_go(item) {
				let ind
				if (item.company.id == 9) {
					this.$router.push({
						name: 'Dqgy',
						query: {
							parent_id: 12,
						}
					})
					return
				}
				if (item.company.id == 3) {
					ind = 0
				} else if (item.company.id == 2) {
					ind = 1
				} else if (item.company.id == 4) {
					ind = 2
				}
				this.$router.push({
					name: 'Coreplate',
					query: {
						parent_id: 9,
						curr: ind
					}
				})
			},
			//文章详情
			goDetail(item) {
				if (item.outlink) {
					window.open(item.outlink, '_blank');
				} else {
					switch (item.type) {
						case 'video':
							this.$router.push({
								path: `video`,
								query: {
									id: item.id
								}
							})
							break;

						case 'news':
							this.$router.push({
								path: `new_detail`,
								query: {
									id: item.id
								}
							})
							break;
						case 'studio':
							this.$router.push({
								path: `studio`,
								query: {
									id: item.id
								}
							})
							break;
						default:
							break;
					}
				}

			},
			// 点击品牌项目图片获取相应列表
			get_list(num, index) {
				this.zidiyiDataIndex = index
				this.pinpai_id = num
				this.getPinPaiXiangMu()
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				get_file_all(data).then((res) => {
					this.zidiyiData = res.data
					this.zidiyiDataIndex = Object.keys(this.zidiyiData)[0]
				}).catch(err => {});
			},
			// 获取自定义富文本
			getZidiyiContent() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				get_content_all(data).then((res) => {
					this.zidiyiContent = res.data
				}).catch(err => {});
			},
			zidiyiDataNext() {
				if (Math.floor(this.categoryListStr.length) / 6 <= 1 || Math.floor(this.categoryListStr.length) / (6 * (
						this
						.zidiyiDataTime +
						1)) <= 1)
					return
				this.zidiyiDataTime++
			},
			zidiyiDataLast() {
				if (this.zidiyiDataTime == 0)
					return
				this.zidiyiDataTime--
			},
			goDetailAbout(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},
			go_brand() {
				this.$router.push({
					path: `group_overview`
				})
			},

			last() {
				if (0 < this.shipinNewsIndex) {
					this.shipinNewsIndex--
				}
			},
			next() {
				if (this.shipinNewsIndex < this.shipinNewsData.length - 1) {
					this.shipinNewsIndex++
				}
			},

			//发展大事件
			getFzdsj() {
				let data = {
					company_id: 1
				}

				history_lst(data).then((res) => {
					if (res.code == 1) {
						this.dataList = res.data
						console.log(res.data, 999)
						if (this.dataList) {
							this.dataList6 = Object.keys(this.dataList).slice(-6)
							this.dataListMin = Object.keys(this.dataList)[0]
							this.dataListMax = Object.keys(this.dataList)[Object.keys(this.dataList).length - 1]
							this.dataListMindex = this.dataListMax
						}
					}
				}).catch(err => {});
			},
			next_zuo() {
				if (this.dataList6.indexOf(this.dataListMindex) != -1) {
					if (this.dataList6.indexOf(this.dataListMindex) == 0)
						return
					else
						this.dataListMindex = this.dataList6[this.dataList6.indexOf(this.dataListMindex) - 1]
					this.dataListTime = 0
				}
			},
			next_you() {
				if (this.dataList6.indexOf(this.dataListMindex) != -1) {
					if (this.dataList6.indexOf(this.dataListMindex) == 5)
						return
					else
						this.dataListMindex = this.dataList6[this.dataList6.indexOf(this.dataListMindex) + 1]
					this.dataListTime = 0
				}
			},
			choose_year(num) {
				this.dataListMindex = num
				this.dataListTime = 0
			},
			dataListTimeNext() {
				this.$refs.welcome.next();
			},
			dataListTimeLast() {
				this.$refs.welcome.prev();
			},

			// 跳转新闻页
			go_news() {
				this.$router.push({
					path: `new_list`,
					query: {
						parent_id: 10
					}
				})
			},
			go_wenhua() {
				this.$router.push({
					path: `new_list`,
					query: {
						parent_id: 10,
						index: 1
					}
				})
			},
			
			go_fzmemorabilia() {
				this.$router.push({
					path: `fzmemorabilia`,
					query: {
						parent_id: 13
					}
				})
			},
			go_list(id) {
				this.$router.push({
					path: `list`,
					query: {
						parent_id: 7,
						id: id
					}
				})
			},
			addLocatPath() {
				let data = {
					directions: '首页',
					path: window.location.href
				}
				add_pv(data).then((res) => {}).catch(err => {});
			},
			getPublic() {
				if (this.publicShow) {
					this.publicShow = false
				} else {
					this.publicShow = true
					this.shoppShow = false
				}
			},
			getShopp() {
				if (this.shoppShow) {
					this.shoppShow = false
				} else {
					this.shoppShow = true
					this.publicShow = false
				}
			},
			p1(index) {
				this.p_index = index
			},
			s1(index) {
				this.s_index = index
			},
			// 获取弹窗公告
			getNotice() {
				let data = {}
				get_notice(data).then((res) => {
					if (res.data == null) {
						this.isProup = false
					} else {
						this.notice = res.data
						this.isProup = true
					}

				}).catch(err => {});
			},
			closeProup() {
				this.isProup = false

			},
			goOutlink(url) {
				window.open(url, "_blank");
			},
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.swiper-container {
		height: 800px;
	}

	.swiper-button-prev::after {
		color: #d6d7dc;
	}

	.swiper-button-next::after {
		color: #d6d7dc;
	}

	/deep/ .swiper-pagination {
		bottom: 60px;
		position: relative;
	}

	/deep/ .swiper-pagination-bullet {
		width: 80px;
		height: 8px;
		background: #ffffff;
		margin-left: 10px;
		border-radius: 0;
	}

	/deep/ .swiper-pagination-bullet-active {
		background: #006170;
	}



	.homepage {
		background: #ffffff;
	}

	.let-spa-1 {
		letter-spacing: -1px;
	}

	.let-spa2 {
		letter-spacing: 2px;
	}

	.let-spa4 {
		letter-spacing: 4px;
	}

	// .toutiao{ margin-top: 40px;}
	.let-spa6 {
		letter-spacing: 6px;
	}

	.let-spa7 {
		letter-spacing: 4px;
	}

	.let-spa8 {
		letter-spacing: 8px;
	}

	.let-spa10 {
		letter-spacing: 10px;
	}

	.content-b {
		width: 200px;

		img {
			width: 20px;
			height: 20px;
		}
	}

	.padding_l_13 {
		padding-left: 13px;
	}


	/*海报轮播 GO*/
	.heading-pic {
		width: 100%;
		height: 100%;

		.pic {
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
	}

	main {
		padding: 0 30px;
	}

	.bg-bai {
		width: 120px;
		height: 120px;
		background: #F0F4F5;
		position: relative;
		left: -32px;
		top: 120px;
		opacity: 0.1;
	}

	a {
		color: #42b983;
	}

	.rotate {
		transform: rotate(180deg);
	}

	.pointer2:hover {
		color: #FFFFFF;
		background: #333333;
	}

	.bg-purple {
		background: #d3dce6;
		height: 50px;
	}

	.arrows_green {
		// width: 20px !important;
	}

	.col-lg-5 {
		width: 20%;
		position: relative;
		min-height: 1px;
		padding-right: 15px;
		padding-left: 15px;
	}

	.gushipic {
		object-fit: cover;
	}

	.sidebar {
		position: fixed;
		border: 1px solid solid;
		z-index: 2;
		right: 150px;
		bottom: 300px;
	}

	.top {
		top: 100px;
	}

	.sidebar .qr {
		position: relative;
		left: -138px;
		top: -142px;
		width: 88px;
		transform: scale(2);
	}

	.sidebar .qr .pic {
		position: absolute;
	}

	.sidebar .public {
		margin: 5px;
	}

	.sidebar .shopping {
		margin: 5px;
	}

	.sidebar .UP {
		margin: 5px;
	}

	.border_1 {
		border: 1px solid #006170;
	}

	.page-top {
		padding: 0 30px;
		background: #FFFFFF;
	}

	.img-responsive {
		width: 100%;
	}

	.el-col {
		padding: 15px;
	}

	.el-image__inner {
		object-fit: cover;
	}

	.row {
		margin-right: 0px;
		margin-left: 0px;
	}

	.col-md_1 {
		width: 8.333333%;
	}

	.col-md-1 {
		width: 13.333333%;
	}

	.col-md-11 {
		width: 86.666667%;
	}

	.col-md_10 {
		width: 73.3333%;
	}

	.left .text-left {
		font-size: 36px;
		color: #006170;
		font-weight: bold;
		padding-bottom: 5px;
	}

	.text-uppercase {
		font-size: 32px;
		color: #006170;
	}

	.pointer2 {
		cursor: pointer;
	}

	.information {
		background: #F0F4F5;
	}

	.times img {
		width: 100px;
		height: 42px;
		object-fit: cover;
		float: left;
		line-height: 42px;
	}

	.time,
	.times {
		line-height: 42px;
		color: #999999;
	}

	.list .enter-the-studio .btn_square {
		height: 26px;
		width: 120px;
		color: #FFFFFF;
		background-color: #006170;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.list_botton .spe {
		float: left;
		line-height: 40px;
	}

	.list_botton .btn_square {
		height: 26px;
		width: 120px;
		color: #FFFFFF;
		background-color: #006170;
	}

	.list_botton .btn_more {
		width: 280px;
		height: 70px;
		float: right;
		font-size: 18px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 15px;
	}

	.list_botton .btn_more span {
		display: table-row-group;
		padding-left: 15px;
		vertical-align: middle;
	}

	.p_back {
		padding: 40px 0;
		background: #f0f4f5;

		.p_back_btn {
			display: flex;

			.p_back_btn-L {
				flex: 1;
				display: flex;
				justify-content: flex-end;
				align-items: center;
			}

			.p_back_btn-R {
				flex: 1;
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}

			.video {
				flex: 6;
			}

			.p_back_btn-L,
			.p_back_btn-R {
				.btn {
					padding: 6px 30px;
					// border: 1px solid #000000;
					border-radius: 0px;

					.glyphicon {
						img {
							width: 30px;
							height: 18px;
						}
					}
				}
			}
		}
	}

	.overflow-X {
		display: inline-block;
		overflow-y: hidden;
		overflow-x: scroll;
	}

	.overflowX {
		margin: 0 !important;
	}



	.m-head-line {
		width: 100%;
		visibility: visible !important;
		padding: 20px 0px 60px 0px;

		.inline-top {
			width: 100%;

			.toutiao {
				margin-top: 80px;
			}

			.b_right {
				height: 300px;
				border-right: 0.5px solid #287A86;
				width: 1px;

				.icon {
					float: right;
				}
			}

			.right {
				.cont {
					height: 300px;
				}

				.anim {
					transition: all 0.5s;
				}

				.list {
					display: flex;
					justify-content: space-between;
					margin-right: -15px;
					padding-right: 15px;

					.b_btn {
						border-bottom: 0.5px solid #F0F4F5;
						margin: 0 0 0px 15px;
						width: 100%;
						display: flex;
						justify-content: space-between;
						height: 88px;
						align-items: center;
					}

					.content {
						display: flex;
						font-size: 9px;
						color: #1A1A1A;
						height: 24px;

						.text {
							margin-bottom: 0px;
							color: #999999;
							margin-right: 30px;
							font-size: 14px;
							font-weight: normal;
							width: 75px;
							float: left;
						}

						.btn_radius {
							border: 1px solid #287A86;
							border-radius: 30px;
							border-color: #287A86;
							color: #287A86;
							margin-right: 15px;
							width: 60px;
							height: 25px;
							text-align: center;
							line-height: 26px;
							display: block;
							padding: 0;
							float: left;
						}
					}
				}

			}
		}
	}

	.text2 {
		color: #1A1A1A;
		vertical-align: middle;
		font-size: 18px;
		font-weight: normal;
		height: 28px;
		padding-left: 4px;
		margin-bottom: 0px;
		max-width: 550px;
	}

	.brand-project .text2 {
		// line-height: 50px;
	}


	.brand-story {
		position: relative;
		width: 100%;
		height: 670px;
	}

	.brand-story .story1 {
		width: 55%;
		height: 616px;
		position: absolute;
		z-index: 1;
		background-size: 100% 100%;
	}

	.brand-story .story1 .story_title {
		padding: 62px 0 0 24%;
	}

	.brand-story .story1 .story_title .text-left {
		color: #FFFFFF;
	}

	.brand-story .story1 .story_title .text-uppercase {
		color: #FFFFFF;
	}

	.brand-story .story1 .txt {
		width: 450px;
		height: 250px;
		/* overflow: hidden; */
		text-overflow: ellipsis;
		text-overflow: ellipsis;
		display: -webkit-box;
		/* -webkit-line-clamp: 8; */
		-webkit-box-orient: vertical;
		position: absolute;
		font-size: 16px;
		top: 220px;
		left: 24%;
		color: #fff;
	}

	.brand-story .story1 .story1_pic {
		width: 55%;
		height: 616px;
		right: 0px;
	}

	.brand-story .story1 .btn_more {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 70px;
		width: 330px;
		color: #006170;
		background-color: #FFFFFF;
		position: absolute;
		right: 0px;
		bottom: 0px;
		font-size: 18px;
	}

	.story1 .btn_more span {
		background: url(~@/assets/img/arrows_green.png) center no-repeat;
	}

	.story1 .btn_more:hover span {
		color: #ffffff;
		background: url(~@/assets/img/arrows_white.png) center no-repeat;
	}

	.story1 .btn_more:hover em {
		color: #ffffff;
	}

	.brand-story .story2 {
		width: 62.8%;
		height: 610px;
		position: absolute;
		right: 0px;
		bottom: 0px;
	}

	.brand-story .story2 .story2_pic {
		float: right;
		height: 610px;
	}

	.m-story {
		padding: 70px 0px 0 0;

		.title {
			font-size: 24px;
			color: #1A1A1A;
			padding-top: 20px;
		}

		.center {
			height: 60px;
			line-height: 30px;
		}

		cite {
			width: 4em;
			border-bottom: 2px solid;
			height: 2px;
			display: block;
			margin: 20px 0 20px 0;
		}

		.time {
			font-size: 18px;
			color: #999999;
			margin-top: 15px;
		}
	}


	/*视频新闻 GO*/
	.m-video {
		margin: 30px 0px;
		padding: 50px 0px;

		.video {
			display: flex;
			align-items: center;
		}

		video {
			width: 100%;
			heihgt: 700px;
		}

		.menu {
			padding-top: 30px;

			.pic {
				width: 20px;
			}

			.right {
				display: flex;
				align-items: center;
			}

			.btn {
				height: 70px;
				background: #EBF3F5;
				color: #006170;
				width: 120px;
				margin: 0px 10px;
				display: flex;
				align-items: center;
				justify-content: center;
			}

		}

		.news-list {
			margin: 0 !important;

			.times {
				.brand {
					position: relative;
					left: -23px;
				}
			}

			.pointer:nth-child(3) .times .brand {
				position: relative;
				left: -35px;
			}

			.title {
				line-height: 30px;
				color: #1A1A1A;
				margin-top: 10px;
				height: 60px;
			}

			.detail {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.brand {
					width: 120px;
					height: 40px;
				}
			}

		}

	}


	/* 品牌故事 GO*/

	.brand-project {
		margin: 0 -30px;
		padding-right: 0px;

		.title {
			.nav_pic {
				height: 820px;
				margin-bottom: 20px;
				height: 120px;
				cursor: pointer;

				.nav_pic_list {
					height: 720px;
					overflow: hidden;

					.pics {
						margin-bottom: 20px;
						height: 100px;
						cursor: pointer;

						border: 1px solid #EBF3F5;

						img {
							width: 100%;
							height: 100px;
							object-fit: cover;
						}
					}
				}

				.pic {
					margin-bottom: 20px;
					height: 100px;
					cursor: pointer;
					border: 1px solid #EBF3F5;
				}

				.active {
					border-color: #006170;
					box-shadow: 5px 7px 10px #cddadc;
				}

				.btn {
					background: #F0F4F5;
					color: #006170;
					display: flex;
					border-radius: 0;
					align-items: center;
					justify-content: center;
					height: 100px;
				}

			}

			.right_pic {
				padding-top: 70px;

				.pic {
					width: 520px;
					height: 70px;
					float: right;
				}
			}
		}

		.information {
			background: #F0F4F5;
			margin-right: -15px;
			padding-left: 31px;
			height: 820px;

			.title {
				color: #287A86;
				line-height: 120px;
				font-size: 30px;
				padding: 10px;

				text {
					padding-left: 30px;
					color: #1A1A1A;
				}

				.t {
					color: #1A1A1A;
					padding-left: 25.5px;
				}
			}

			.list {
				display: flex;
				justify-content: space-between;
				padding: 10px;
				height: 100px;
				align-items: center;

				.content-b {
					font-size: 14px;
					// padding-top: 10px;
					color: #999999;
					display: flex;
					align-items: center;

				}

				.content {
					text {
						font-size: 7px;
						color: #999999;
						padding-right: 30px;
					}

					.btn_radius {
						text-transform: uppercase;
						letter-spacing: 2px;
						border-radius: 300px;
						border-color: #287A86;
						display: inline-block;
						color: #287A86;
						margin-right: 15px;
						margin-left: 29.5px;
						border: 1px solid;
						background: none;
						width: 60px;
						text-align: center;
						line-height: 25px;
						height: 25px;
					}
				}
			}

			.b_btn {
				border-bottom: 0.5px solid #E6E6E6;
			}
		}

		.list_botton {
			padding: 50px 0px;
			height: 150px;
			position: absolute;
			bottom: 10px;
			right: 16%;
		}

	}




	/* 党群公益 GO*/
	.m-charity {
		padding-top: 70px;

		.title {
			padding-bottom: 15px;
		}

		.information {
			padding: 20px 0px 20px 20px;
			margin-bottom: 40px;

			.ncol-md-6 {
				padding-right: 0px;
				padding-left: 30px;
			}

			.title {
				font-size: 24px;
				color: #333333;
				line-height: 40px;
				height: 88px;
				padding-bottom: 20px;
				border-bottom: 0.5px solid #d4d8d8;
			}

			.text-left {
				font-size: 18px;
				color: #666666;
				padding-top: 35px;
				line-height: 30px;
				min-height: 125px;
				padding-right: 2em;
			}

			.list_botton {
				color: #999999;
				padding-right: 2em;
				margin-top: 96px;

				btn_square {
					height: 26px;
					width: 120px;
					color: #FFFFFF;
					background-color: #006170;
				}

				.btn_more {
					width: 178px;
					height: 40px;
					float: right;

					span {
						padding-left: 15px;
						vertical-align: middle;
					}
				}

			}
		}

	}

	/* 发展大事纪 GO*/
	.m-great-things {
		width: 100%;
		background: #006170;
		background-image: url(~@/assets/img/developBgd.jpg);
		color: #FFFFFF;
		height: auto;
		margin-top: 70px;
		padding: 50px 30px;

		.head {
			.left {
				width: 100%;

				.text-left {
					color: #FFFFFF;
				}

				.text-uppercase {
					color: #FFFFFF;
				}
			}

			.right {
				height: 148px;
				display: flex;
				justify-content: flex-end;
				align-items: center;

				.panel {
					background: transparent;
					margin-bottom: 0px;
					display: -webkit-box;
					justify-content: space-between;
					flex-direction: row-reverse;
					/* width: 55%; */
					position: absolute;
					left: 36%;
					overflow: hidden;

					span {
						display: flex;
						justify-content: center;
						align-items: center;
						width: 100px;
						height: 40px;
						font-size: 20px;
						border: 0.5px solid #F0F4F5;
						margin: 0px 10px;
						color: #F0F4F5;
						opacity: 0.5;

						&.active {
							border: 2px solid #FFFFFF;
							color: #FFFFFF;
							opacity: 1;
							font-weight: bold;
						}
					}


					// .b {
					// 	margin-left: 10px;
					// 	opacity: 0.5;
					// 	display: flex;

					// 	.btn {
					// 		width: 40px;
					// 		font-size: 20px;
					// 		line-height: 26px;
					// 		border-radius: 0px;
					// 	}
					// }

				}

			}

		}

		.nav-list {
			padding: 0px 20px 0px 20px;
			top: -57px;

			.list {
				p {
					line-height: 2;
				}

				h2 {
					display: flex;
					align-items: center;

					span {
						width: 20px;
						height: 20px;
						background: #FFFFFF;
						margin-right: 20px;
					}
				}

				small {
					color: #FFFFFF;
					float: right;
					padding-left: 44px;
				}

			}
		}

		.go_direction {
			display: flex;
			justify-content: space-around;

			.btn {
				background: #FFFFFF;
				color: #006170;
				margin: 0 10px;
				align-items: center;
				justify-content: center;
				display: flex;
				width: 120px;
				height: 80px;
				font-size: 20px;
				border-radius: 0px;
			}

			.btn:hover {
				background: #F0F4F5;
			}
		}
	}


	/* 企业动态 GO*/
	.m-monthly {
		margin-top: 70px;

		.inline-top,
		.el-row .bar {
			padding: 32px 0px;
		}

		.text-uppercase {
			margin-bottom: 30px;
		}

		.left-block {
			display: flex;

			.pointer-blck {
				flex: 1;
				position: relative;
			}

			.pointer-blck:hover {
				cursor: pointer;
				background: #f0f4f5;
				padding: 20px 20px 0 20px;
				margin: -20px -20px 0 -20px;
			}

			.pointer-blck:nth-child(2) {
				margin-left: 40px;
			}

			.pointer-blck:nth-child(2):hover {
				margin: -20px -20px 0 20px;
			}
		}

		.pic {
			.brand {
				width: 100%;
				height: 180px;
				overflow: hidden;
				object-fit: cover;
				// padding-top: 26px;
			}
		}

		.title {
			width: 100%;
			font-size: 18px;
			color: #1A1A1A;
			line-height: 30px;

			margin: 0px;
			padding: 0px;
			position: relative;
			left: -20px;
			display: flex;
			align-items: center;
			padding: 10px 20px 15px 20px;
			width: calc(100% + 40px);
		}

		.title ::after {
			width: calc(100% - 40px);
			content: '';
			position: absolute;
			height: 1px;
			background: #f0f4f5;
			bottom: 0px;
			left: 20px;
		}

		.b_btn {
			border-bottom: 0px solid #E6E6E6 !important;
		}

		.bottom {
			display: flex;

			.bottom_left {
				flex: 1;
			}

			.bottom_right {
				flex: 1;
				margin-left: 40px;
			}
		}

		.list {
			margin: 0px;
			padding: 0px;
			height: 90px;
			position: relative;
			left: -20px;
			display: flex;
			align-items: center;
			padding: 0 20px;
			width: calc(100% + 40px);
		}

		.list::after {
			width: calc(100% - 40px);
			content: '';
			position: absolute;
			height: 1px;
			background: #f0f4f5;
			bottom: 0px;
			left: 20px;
		}

		.list:hover::after {
			background: #f0f4f5;

		}

		.list:nth-child(3n)::after {
			background: #f0f4f5;
		}

		.content {
			font-size: 12px;
			color: #1A1A1A;
			line-height: 40px;
			display: flex;

			.text {
				font-size: 14px;
				font-weight: normal;
				color: #999999;
				padding-right: 30px;
			}

		}

		.list_botton {
			padding: 10px;
			margin: 45px 0px;
			display: flex;
			justify-content: center;
		}

	}


	/*员工风采 GO*/
	.m-staff {
		.title {
			font-size: 18px;
			line-height: 30px;
			color: #1A1A1A;
			margin-top: 20px;
			height: 60px;
		}

		.detail {
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: #999999;

			.brand {
				width: 120px;
				height: 30px;
			}
		}

		.time {
			margin-top: 10px;
		}

	}

	/*影视作品*/

	.m-films {
		margin-top: 70px;
		margin-bottom: 124px;

		.nav_list {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
		}

		.list {
			padding: 15px;
		}

		.list:hover {
			background: #E6E6E6;
		}

		.title {
			line-height: 30px;
			color: #1A1A1A;
			margin-top: 20px;
			font-size: 24px;
		}

		.detail {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.brand {
				width: 120px;
				height: 30px;
			}

		}
	}

	.hover_img:hover {
		transform: scale(1.2)
	}

	.pic {
		overflow: hidden;
		object-fit: cover;
	}

	.pic_h180 {
		img {
			height: 180px;
		}

		height: 180px;
	}

	.pic_h242 {
		img {
			height: 242px;
		}

		height: 242px;
	}

	.pic_h264 {
		img {
			height: 264px;
		}

		height: 264px;
	}

	.pic_h357 {
		img {
			height: 357px;
		}

		height: 357px;
	}

	.nav_list.overflowX .pic {
		height: 440px;
	}

	.dj_ovhd {
		overflow: hidden;
		padding: 0 !important;
	}

	.mask_proup {
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, .5);
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
	}

	.proup {
		width: 960px;
		height: 420px;
		background: #ffffff;
		position: fixed;
		top: 50%;
		left: 50%;
		z-index: 99;
		margin: -210px 0 0 -480px;

	}

	.proup .cont {
		position: relative;
	}

	.proup .close-proup {
		width: 50px;
		height: 30px;
		line-height: 30px;
		position: absolute;
		top: -30px;
		right: 0px;
		z-index: 99;
		color: #ffffff;
		text-align: center;
		cursor: pointer;
		background: rgba(0, 0, 0, 0.2);
	}

	.proup .close-proup:hover {
		background: #006170;
		color: #ffffff;
	}

	.cont .pic {
		width: 680px;
		height: 420px;
		overflow: hidden;
		display: block;
		float: left;
		position: relative;
	}

	.proup .pic img {
		width: 680px;
		height: 420px;
		object-fit: cover;
		cursor: pointer;
	}


	.proup .pic .txt {
		position: absolute;
		right: -100%;
		bottom: 0px;
		width: 340px;
		line-height: 40px;
		font-size: 16px;
		margin: 0 auto;
		z-index: 9;
		color: #ffffff;
		text-indent: 2em;
		background: rgba(0, 97, 112, 0.8);
	}

	.proup .pic .txt1 {
		bottom: 42px;
		right: -150%;
	}

	.proup .txt span {
		position: relative;
		color: #ffffff;
	}

	.proup .cont:hover .txt1,
	.proup .cont:hover .txt2 {
		right: 0;
	}

	.info {
		width: 280px;
		height: 420px;
		background: #006170;
		float: left;
		text-align: center;
	}

	.proup .info .logo {
		width: 141px;
		height: 75px;
		margin: 40px auto;
	}

	.proup .info .qrcode {
		width: 180px;
		height: 180px;
		margin: 0px auto;
		object-fit: cover;
	}


	.proup .tit {
		width: 96%;
		overflow: hidden;
		margin: 40px auto 0;
		text-align: center;
		color: #ffffff;
		font-size: 18px;
	}

	.scroll-wrap {
		transform: rotate(180deg);

		.b_btn {
			transform: rotate(180deg);
		}

	}

	.scroll_parent_box {
		width: 100%;
		height: 264px;
		overflow: hidden;
		box-sizing: border-box;
		padding: 0 10px;
		transition: all 0ms ease-in 0s;
		position: relative;
		overflow: hidden;

		.big {
			width: 100%;
			background: #ffffff;
			position: absolute;
			height: 88px;
			overflow: hidden;
			top: 88px;
			left: 0px;
			z-index: 99;
			border-left: 1px solid #D9D9D9 !important;
			border-right: 1px solid #D9D9D9 !important;
			box-shadow: 0px 0px 5px #D9D9D9, 0px 0px 5px #D9D9D9;

			.b_btn {

				border: 1px solid #ffffff !important;

				.content-b {
					margin-top: 6px;
					width: 250px !important;
				}

				img {
					width: 30px !important;
					height: 30px !important;
					position: relative;
					top: -4px;
				}

				.btn_radius {
					width: 80px;
					height: 30px;
					line-height: 30px;
					font-size: 18px;
				}

				.btn_square {
					width: 140px;
					height: 35px;
					line-height: 35px;
					font-size: 24px;
					position: relative;
					top: 4px;
				}

				.text {
					width: 110px !important;
					font-size: 20px !important;
				}

				.text2 {
					max-width: 420px !important;
					font-size: 24px !important;
				}

				.btn_radius {}
			}
		}
	}


	.scroll_list {
		transition: all 0ms ease-in 0s
	}


	img {
		object-fit: cover;
		width: 100%;
	}

	.b_more {
		width: 120px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		border: 1px solid #F0F4F5;
		cursor: pointer;
	}

	@media screen and (max-width: 1200px) {
		.m-head-line .inline-top .b_right {
			border-right: 0px solid #287A86;
		}
	}

	@media screen and (max-width: 1400px) {
		.m-head-line .inline-top .b_btn {
			margin: 0;
		}

		.m-charity .information .list_botton {
			color: #999999;
			padding-right: 2em;
			margin-top: 20px;
		}

		.m-great-things .head .right .panel span {
			width: 72px !important;
		}
	}
</style>
